import { useFAClientsData } from '../../../hooks/useFAClientsData';
import { useSPClientsData } from '../../../hooks/useSPClientsData';
import { FAClientLeaderboard } from '../leaderboards/FAClientLeaderboard';
import { SPClientLeaderboard } from '../leaderboards/SPClientLeaderboard';
import { NetworkCoverageSection } from './NetworkCoverageSection';
import type { AnalyticsQueryParams } from '../../../types/analytics.types';

type NetworkSupplyTabProps = {
  queryParams: AnalyticsQueryParams;
  isActive?: boolean;
};

export const NetworkSupplyTab = ({ queryParams, isActive = true }: NetworkSupplyTabProps) => {
  const fa = useFAClientsData(
    queryParams.partnerCompanyId || queryParams.excludeInternal !== undefined
      ? {
          partnerCompanyId: queryParams.partnerCompanyId,
          excludeInternal: queryParams.excludeInternal,
        }
      : undefined,
    isActive,
  );

  const sp = useSPClientsData(undefined, isActive);

  const exportParams: Record<string, string | boolean> = {};
  if (queryParams.partnerCompanyId) exportParams.partnerCompanyId = queryParams.partnerCompanyId;
  if (queryParams.excludeInternal !== undefined) exportParams.excludeInternal = queryParams.excludeInternal;

  return (
    <div className="space-y-8 pt-6">
      <NetworkCoverageSection queryParams={queryParams} isActive={isActive} />
      <section>
        <FAClientLeaderboard
          advisors={fa.advisors}
          totalCount={fa.totalCount}
          search={fa.search}
          setSearch={fa.setSearch}
          sortBy={fa.sortBy}
          sortOrder={fa.sortOrder}
          handleSort={fa.handleSort}
          showPendingInvitations={fa.showPendingInvitations}
          setShowPendingInvitations={fa.setShowPendingInvitations}
          isLoading={fa.isLoading}
          isError={fa.isError}
          hasNextPage={fa.hasNextPage ?? false}
          isFetchingNextPage={fa.isFetchingNextPage}
          fetchNextPage={() => fa.fetchNextPage()}
          onRetry={() => fa.refetch()}
          exportParams={exportParams}
        />
      </section>
      <section>
        <SPClientLeaderboard
          providers={sp.providers}
          totalCount={sp.totalCount}
          search={sp.search}
          setSearch={sp.setSearch}
          sortBy={sp.sortBy}
          sortOrder={sp.sortOrder}
          handleSort={sp.handleSort}
          isLoading={sp.isLoading}
          isError={sp.isError}
          hasNextPage={sp.hasNextPage ?? false}
          isFetchingNextPage={sp.isFetchingNextPage}
          fetchNextPage={() => sp.fetchNextPage()}
          onRetry={() => sp.refetch()}
          exportParams={exportParams}
        />
      </section>
    </div>
  );
};
